module.exports = __webpack_public_path__ + "img/gb-sct.63719ae5.svg";